var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetromakroAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#014171",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5627_1078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.952 24.0481H12.048V47.9521H59.952V24.0481Z",
    fill: "#014171",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3204 37.9593C54.3095 38.0445 54.2773 38.2687 53.9854 38.2978H51.421C51.129 38.2687 51.0757 38.0445 51.0647 37.9593V34.0005C51.0756 33.9151 51.116 33.7336 51.408 33.7045H53.9865C54.2786 33.7336 54.3095 33.9151 54.3204 34.0005V37.9593ZM55.2083 32.2129H50.1768C49.4208 32.2739 48.7822 32.6573 48.697 33.5151V38.4163C48.7822 39.2741 49.4208 39.7285 50.1768 39.7895H55.2083C55.9643 39.7285 56.6028 39.2741 56.6881 38.4163V33.5151C56.6028 32.6573 55.9643 32.2739 55.2083 32.2129ZM34.8457 33.7045H32.5963V32.2129H39.4629V33.7045H37.2134V39.7895H34.8457V33.7045ZM31.8861 33.7045V32.2129H25.7298V39.7895L31.9679 39.7879L31.9701 38.2979H28.1036L28.104 36.6752H31.886V35.1873H28.104V33.7045L31.8861 33.7045ZM45.619 34.8788C45.619 35.0428 45.5782 35.1867 45.2839 35.1867H42.5409V33.6995H45.2874C45.6215 33.6995 45.619 33.9181 45.619 34.0546V34.8788ZM46.2749 36.8441C47.0135 36.785 47.7499 36.2822 47.7499 35.4566V33.5861C47.6642 32.7323 47.0236 32.2712 46.2642 32.2104H40.1731L40.1733 39.7895H42.5409V36.8441H43.4832L45.0222 39.7895H47.7452L45.9125 36.8441H46.2749ZM20.8287 39.7895L22.4151 35.0304V39.7895H24.7828V32.2129H21.5864L20.0474 36.0013L18.5083 32.2129H15.312V39.7895H17.6797V35.0304L19.2778 39.7895H20.8287Z",
    fill: "#FBC51D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5627_1078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    fill: "white",
    transform: "translate(12 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetromakroAppIcon);
export default __webpack_public_path__ + "static/media/metromakro-app-icon.ed5afd6a0df57fdce10a1a3a10e4ae38.svg";
export { ForwardRef as ReactComponent };